export enum MS_TEAMS_STORAGE_KEYS {
    FOXIT_TOKEN = 'FOXIT_TOKEN__WITHIN_TEAMS',
    MS_GRAPH_TOKEN = 'MS_GRAPH_TOKEN__WITHIN_TEAMS',
}
